import { BRAND_OG_IMAGE_URL, BRAND_PERSON_NAME, BRAND_SITE_URL } from "@/lib/brandConfig";
import profileImage from "@/assets/profile-delfu.jpg";
import reel1 from "@/assets/reel-1.jpg";
import reel2 from "@/assets/reel-2.jpg";
import reel3 from "@/assets/reel-3.jpg";
import { BaseTemplate } from "@/components/templates/BaseTemplate";
import { BioLinkTemplate } from "@/components/templates/BioLinkTemplate";
import { useTemplateSelection } from "@/hooks/useTemplateSelection";
import { useSEO } from "@/hooks/useSEO";

type MediaItem = {
  id: number;
  type: "video" | "photo";
  src: string;
  embedId?: string;  // For Streamable videos
  cloudflareId?: string;  // For Cloudflare Stream videos
  title: string;
};

const mediaItems: MediaItem[] = [
  { 
    id: 1, 
    type: "video", 
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/55af92c0a6afac58e780413127c73c5c/thumbnails/thumbnail.jpg", 
    cloudflareId: "55af92c0a6afac58e780413127c73c5c", 
    title: "" 
  },
  { 
    id: 2, 
    type: "video", 
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/27cbea077c11d9cc0569774b8c443a04/thumbnails/thumbnail.jpg", 
    cloudflareId: "27cbea077c11d9cc0569774b8c443a04", 
    title: "" 
  },
  { 
    id: 3, 
    type: "video", 
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/55af92c0a6afac58e780413127c73c5c/thumbnails/thumbnail.jpg", 
    cloudflareId: "55af92c0a6afac58e780413127c73c5c", 
    title: "" 
  },
  {
    id: 4,
    type: "photo",
    src: reel1,
    title: "Professional Modeling"
  },
  {
    id: 5,
    type: "photo",
    src: reel2,
    title: "Fashion Photography"
  },
  {
    id: 6,
    type: "photo",
    src: profileImage,
    title: "Portrait Session"
  },
  {
    id: 7,
    type: "video",
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/27cbea077c11d9cc0569774b8c443a04/thumbnails/thumbnail.jpg",
    cloudflareId: "27cbea077c11d9cc0569774b8c443a04",
    title: ""
  },
  {
    id: 8,
    type: "photo",
    src: reel3,
    title: "Creative Modeling"
  },
  {
    id: 9,
    type: "photo",
    src: "https://imagedelivery.net/N5r9mtOgBIolYeX8w64oqg/e9f2e4fc-fbf1-4ead-6e36-c8d2b9917d00/public",
    title: "Model Lifestyle"
  },
  {
    id: 10,
    type: "photo",
    src: "https://imagedelivery.net/N5r9mtOgBIolYeX8w64oqg/5693d23a-20a6-4e89-9cb9-806ca3ccc900/public",
    title: "Fashion Model"
  },
  {
    id: 11,
    type: "photo",
    src: "https://imagedelivery.net/N5r9mtOgBIolYeX8w64oqg/2fe5d4c8-fefd-49a3-c53b-6736465a1b00/public",
    title: "Professional Model"
  },
  {
    id: 12,
    type: "video",
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/0599f80309c4103f7ebe835cf09f5a41/thumbnails/thumbnail.jpg",
    cloudflareId: "0599f80309c4103f7ebe835cf09f5a41",
    title: ""
  },
  {
    id: 13,
    type: "video",
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/905a888c2c2c99b75ac5c03f3ab98aaa/thumbnails/thumbnail.jpg",
    cloudflareId: "905a888c2c2c99b75ac5c03f3ab98aaa",
    title: ""
  },
];

export const Modelo = () => {
  const { region, shouldUseBaseTemplate, shouldUseBioLinkTemplate } = useTemplateSelection();

  // Enhanced SEO configuration with Model focus
  const seoConfig = {
    title: region === "US" 
      ? `${BRAND_PERSON_NAME} | Professional Model & Content Creator - Join My Community`
      : `${BRAND_PERSON_NAME} - Modelo Argentina | Portfolio y Sesiones Profesionales`,
    description: region === "US" 
      ? `Join professional model ${BRAND_PERSON_NAME}'s exclusive community! Get access to premium modeling content, join our Telegram group, and connect directly. Your gateway to exclusive fashion and lifestyle content.`
      : `${BRAND_PERSON_NAME} modelo profesional argentina. Portfolio de sesiones fotográficas, campañas publicitarias y contenido de moda. Disponible para colaboraciones creativas.`,
    keywords: region === "US"
      ? `${BRAND_PERSON_NAME}, professional model, fashion model, lifestyle model, premium content, exclusive access, modeling portfolio, content creator, community`
      : `modelo, ${BRAND_PERSON_NAME} modelo, argentina modelo, modelo instagram, sesiones fotograficas, moda, lifestyle, portfolio modelo, modelo profesional`,
    ogImage: BRAND_OG_IMAGE_URL,
    ogTitle: region === "US"
      ? `${BRAND_PERSON_NAME} | Professional Model & Content Creator - Join My Community`
      : `${BRAND_PERSON_NAME} - Modelo Argentina`,
    ogDescription: region === "US"
      ? "Join my exclusive community! Premium modeling content, fashion photography, and direct connection. Let's create beautiful content together! 📸✨"
      : "Modelo profesional argentina. Portfolio de sesiones fotográficas, moda y lifestyle. Elegancia natural con autenticidad.",
    canonical: `${BRAND_SITE_URL}/modelo`,
    author: BRAND_PERSON_NAME,
    publishedTime: "2026-01-01T00:00:00.000Z",
    modifiedTime: new Date().toISOString(),
    type: region === "US" ? "profile" : "website",
    locale: region === "US" ? "en_US" : "es_AR",
    alternateLocale: region === "US" ? "es_AR" : "en_US",
  };

  useSEO(seoConfig);

  // Use template based on feature flags
  if (shouldUseBioLinkTemplate()) {
    return <BioLinkTemplate mediaItems={mediaItems} />;
  }

  // Default to BaseTemplate (LATAM style)
  return <BaseTemplate mediaItems={mediaItems} />;
};

export default Modelo;